"use client";
import ExploretheDuncan from "@/components/aboutus/ExploretheDuncan";
import OurStory from "@/components/aboutus/OurStory";
import OurTeam from "@/components/aboutus/OurTeam";
import ScotchWhisky from "@/components/aboutus/ScotchWhisky";
import BuyNowCart from "@/components/common/BuyNowCart";
import SignupForFree from "@/components/landingpage/SignupForFree";
import NewMainLayout from "@/components/layout/newMainLayout";
import ScoMeta from "@/components/scometa";
import { getCheckoutLineItems } from "@/util/utils";
import { useAppCommonStore } from "@/zustand/appCommon";
import React, { useEffect, useState } from "react";

const Aboutus = (props: any) => {
  const { data, meta } = props;
  const [aboutusData, setAboutusData]: any = useState(null);
  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  useEffect(() => {
    if (data) {
      setAboutusData(data?.data?.attributes?.blocks);
    }
  }, [data]);

  const renderAboutusPage = () => {
    return (
      <>
        {aboutusData && aboutusData.length > 0
          ? aboutusData.map((content: any, index: any) => {
              switch (content.__component) {
                case "about.info-banner":
                  return (
                    <div key={index}>
                      <ScotchWhisky
                        key={content?.id + index}
                        data={content}
                      />
                    </div>
                  );
                case "about.our-story-timeline":
                  return (
                    <OurStory
                      key={content?.id + index}
                      data={content}
                    />
                  );

                case "about.our-team":
                  return (
                    <OurTeam
                      key={content?.id + index}
                      data={content}
                    />
                  );

                case "about.explore-our-whisky":
                  return (
                    <ExploretheDuncan
                      data={content}
                      key={content?.id + index}
                    />
                  );

                default:
                  return null;
              }
            })
          : null}
      </>
    );
  };

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  return (
    <>
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      {aboutusData && (
        <NewMainLayout
          checkout={checkout}
          toggleCartSidebar={toggleCartSidebar}
        >
          {aboutusData && renderAboutusPage()}
          <SignupForFree />
        </NewMainLayout>
      )}
    </>
  );
};

export default Aboutus;
